import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=49038170"
import script from "./Bill.vue?vue&type=script&lang=ts"
export * from "./Bill.vue?vue&type=script&lang=ts"
import style0 from "./Bill.vue?vue&type=style&index=0&id=49038170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports